<template>
  <path :class="classNames" @click.prevent="clickPath" :d="compPath"></path>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  // See MenuItem.vue's comment for why this is required in Vue 3.
  emits: ['click'],
  methods: {
    clickPath () {
      this.$emit('click')
    }
  },
  computed: {
    ...mapGetters(['tool']),
    classNames () {
      let c = `path ${this.path.type} ${this.path.color}`
      if (this.tool === 'eraser') {
        c += ' erase'
      }
      return c
    },
    compPath () {
      let path = ''
      const points = this.path.points
      if (points.length > 0) {
        path = `M ${points[0].x * this.width} ${points[0].y * this.height}`
        let p1, p2, end
        for (let i = 1; i < points.length - 2; i += 2) {
          p1 = points[i]
          p2 = points[i + 1]
          end = points[i + 2]
          path += ` C ${p1.x * this.width} ${p1.y * this.height}, ${p2.x * this.width} ${p2.y * this.height}, ${end.x * this.width} ${end.y * this.height}`
        }
        return path
      }
    }
  },
  props: ['path', 'width', 'height']
}
</script>

<style>

</style>
